import config from 'config'

const { chatServerUrl: MATRIX_CHAT_SERVER_URL } = config

export const END_USER_REGEX = /^@(?<uuid>[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})_(?<account_id>\d{1,12})_e:.*$/
export const AGENT_USER_REGEX = /^@(?<agent_id>\d{1,12})_(?<account_id>\d{1,12})_a:.*$/
export const SUPER_USER_REGEX = /^@(?<agent_id>\d{1,12})_s:.*$/
export const BOT_USER_REGEX = /^@chat-admin:.*$/
export const CHAT_ADMIN_NAME = 'Bot'

export function isEndUser(userId) {
  if (!userId) return false
  return userId.match(END_USER_REGEX) !== null
}

export function isAgentUser(userId) {
  if (!userId) return false
  return userId.match(AGENT_USER_REGEX) !== null
}

export function isSuperUser(userId) {
  if (!userId) return false
  return userId.match(SUPER_USER_REGEX) !== null
}

export function isBotUser(userId) {
  if (!userId) return false
  return userId.match(BOT_USER_REGEX) !== null
}

export function isUser(userId) {
  if (!userId) return false
  return (
    userId.match(END_USER_REGEX) !== null ||
    userId.match(AGENT_USER_REGEX) !== null ||
    userId.match(SUPER_USER_REGEX) !== null
  )
}

export function getUserType(userId) {
  if (userId.includes('_e:')) return 'enduser'
  if (userId.includes('_a:')) return 'agentuser'
  if (userId.includes('_s:')) return 'superuser'
  return 'adminuser'
}

export function getChatAdminUserId() {
  const MATRIX_CHAT_SERVER_HOST = MATRIX_CHAT_SERVER_URL.replace(
    /https?:\/\//g,
    ''
  )
  return `@chat-admin:${MATRIX_CHAT_SERVER_HOST}`
}
